import { required, isPhone, isEmail, hasNotSpecialCharacters } from '../../utils/validations'

const validate = ({ firstName, lastName, phoneNumber, email }: any) => ({
  firstName: required(firstName) || hasNotSpecialCharacters(firstName),
  lastName: required(lastName) || hasNotSpecialCharacters(lastName),
  phoneNumber: isPhone(phoneNumber),
  email: isEmail(email),
})

export default validate
